import { RocketLaunch } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ExerciseInterface } from "../../../../interfaces/examInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../../..";
import {
  BoxLinesNumberPoints,
  BoxNumber,
  BoxNumberPoints,
  BoxTitleExercise,
  ExerciseContainer,
  ExerciseImage,
  ExerciseNumber,
  ExercisePoints,
  LinesNumberPoints,
  PointsContainerPdf,
  PointsPdf,
  Rocket,
  SpacerLeft,
} from "./GrandCombinStyles";

export const GrandCombinPDFExercise = ({
  exercise,
  imageUrl,
  solutionImageUrl,
  zoomFactor,
  groupColorDark,
  groupColorLight,
}: {
  exercise: ExerciseInterface;
  imageUrl: string;
  solutionImageUrl: string;
  zoomFactor: number;
  groupColorDark: string;
  groupColorLight: string;
}) => {
  const showSolutions = useSelector((state: RootState) => state.examBuilder.main.showSolutions);

  return (
    <>
      <Box>
        <ExerciseContainer zoomfactor={zoomFactor}>
          <SpacerLeft zoomfactor={zoomFactor}></SpacerLeft>
          <BoxTitleExercise zoomfactor={zoomFactor}>
            <BoxNumberPoints zoomfactor={zoomFactor}>
              <BoxNumber zoomfactor={zoomFactor} selectedColor={groupColorDark}>
                <ExerciseNumber zoomfactor={zoomFactor}>Aufgabe {exercise.index + 1}</ExerciseNumber>
              </BoxNumber>

              <BoxLinesNumberPoints zoomfactor={zoomFactor}>
                <LinesNumberPoints zoomfactor={zoomFactor} selectedColor={groupColorLight}></LinesNumberPoints>

                {exercise.showRocket && (
                  <Rocket zoomfactor={zoomFactor}>
                    <RocketLaunch />
                  </Rocket>
                )}
              </BoxLinesNumberPoints>

              <ExercisePoints zoomfactor={zoomFactor}>
                <PointsContainerPdf zoomfactor={zoomFactor}>
                  <PointsPdf zoomfactor={zoomFactor}>/ {exercise.points}</PointsPdf>
                </PointsContainerPdf>
              </ExercisePoints>
            </BoxNumberPoints>
            <ExerciseImage zoomfactor={zoomFactor}>
              <img src={showSolutions ? solutionImageUrl : imageUrl} alt="" />
            </ExerciseImage>
          </BoxTitleExercise>
        </ExerciseContainer>
      </Box>
    </>
  );
};

export default GrandCombinPDFExercise;
